module.exports = __webpack_public_path__ + "img/day-4.20f5e28d.png";